import React from 'react';

import ReportPage from '../../common/ReportPage';

import { fetchGetImportTaskById } from '../../../actions/imports';

const ExportReportPage = (props) => {
  return <ReportPage {...props} getAction={fetchGetImportTaskById} />;
};

export default ExportReportPage;
